<template>
  <div class="page">
    <!-- 搜索 -->
    <!-- <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="ID">
                  <el-input  v-model="queryForm.id"></el-input>
              </el-form-item>
              <el-form-item label="文件名">
                  <el-input  v-model="queryForm.fileName"></el-input>
              </el-form-item>
              <el-form-item label="新文件名">
                  <el-input  v-model="queryForm.newFileName"></el-input>
              </el-form-item>
              <el-form-item label="文件类型">
                  <el-input  v-model="queryForm.fileType"></el-input>
              </el-form-item>
              <el-form-item label="文件后缀">
                  <el-input  v-model="queryForm.fileSuffix"></el-input>
              </el-form-item>
              <el-form-item label="文件路径">
                  <el-input  v-model="queryForm.filePath"></el-input>
              </el-form-item>
              <el-form-item label="文件大小">
                  <el-input  v-model="queryForm.fileSize"></el-input>
              </el-form-item>
              <el-form-item label="文件夹">
                  <el-input  v-model="queryForm.folderId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppFileList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form> -->
    <div class="page-content" v-if="switchof1">
      <div class="page-tool-bar" style="padding:10px">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addMppFile">上传
          </el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteMppFile(null)">删除</el-button>
          <el-cascader
            style="margin-left: 10px;width:150px"
            :options="treess"
            v-model="editFolder"
            placeholder="文件移动至"
            :disabled="multipleSelection.length <= 0"
            size="small"
            :props="{ checkStrictly: true, label: 'folderName', value: 'id', emitPath:false }"
            clearable>
          </el-cascader>
          <el-button style="margin-left: 10px;" type="primary" size="small" icon="el-icon-rank" :disabled="multipleSelection.length <= 0 || editFolder == ''" @click="editMpp()">移动
          </el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
<!--          <span title="下载模板" class="icon-box" @click="importTemplate">-->
<!--            <Icon color="#606266">-->
<!--              <ArrowDown />-->
<!--            </Icon>-->
<!--          </span>-->
<!--          <span class="icon-box" title="导入数据" @click="isImport">-->
<!--            <Icon color="#606266">-->
<!--              <ArrowExportUp24Regular />-->
<!--            </Icon>-->
<!--          </span>-->
<!--          <span title="导出数据" class="icon-box" @click="exportMppFileList">-->
<!--            <Icon color="#606266">-->
<!--              <ArrowDownload24Regular />-->
<!--            </Icon>-->
<!--          </span>-->
          <span class="icon-box" @click="refreshMppFileList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
          <span style="height: 100%;margin-left: 10px;position: relative;top: -5px;">
            <el-radio-group v-model="switchof1">
              <el-radio-button :label="true"><i class="el-icon-menu"></i></el-radio-button>
              <el-radio-button :label="false"><i class="el-icon-s-operation"></i></el-radio-button>
            </el-radio-group>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <div class="content">
        <div class="pictrueArea">
          <div class="items">
            <div class="pictrueitem" v-for="item, key in mppFileList" :key="key"  @mouseenter="mouseoverleave(item.id, true)"
                @mouseleave="mouseoverleave(item.id, false)">
              <p class="number" v-show="item.checked">
                <el-badge :value="item.number" class="item" type="primary">
                </el-badge>
              </p>
              <div :class="item.checked ? 'imgOn' : 'img'">
                <img @click="handleSelectionChange(item.id)"
                  :src="item.fileIcon"
                  style="width: 130px;height: 133px;">
              </div>
              <div class="operate-item">
                <p v-if="!item.edit">{{ item.fileName }}</p>
                <el-input v-else v-model="item.inp" size="small" placeholder="请输入内容"></el-input>
                <div class="operate-height" v-show="item.hover">
                  <span @click="deleteMppFile(item.id)">删除</span>
                  <span @click="edit1(item.id)">{{ item.edit == true ? '确定' : '改名' }}</span>
                  <span v-if="item.fileType >= 2 && item.fileType <= 5" @click="updateSrcList(item.fileUrl)">
                    <el-image
                      ref="image" v-show="false" style="width: 10px; height: 10px"
                      :src="item.fileUrl"
                      :preview-src-list="srcList">
                    </el-image>
                    查看</span>
                  <span v-else-if="item.fileType == 1 || item.fileType == 6 || item.fileType >= 8" @click="onUpload(item.fileUrl)">
                    下载
                  </span>
                  <span v-else-if="item.fileType == 7" @click="playVideoVideo(item.fileUrl)">
                    播放
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="pagination-box">
          <el-pagination @size-change="sizeChanges" @current-change="currentChange" :current-page.sync="currentPage"
            :page-sizes="[50, 100, 150, 200]" :page-size="pageSizes" layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum" background :pager-count="7">
          </el-pagination>
        </div>
      </div>
    </div>

    <div class="page-content1" v-else>
      <div class="content">
        <div class="page-tool-bar" style="padding: 10px;">
          <div class="el-btn-group">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addMppFile">上传
            </el-button>

            <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
              @click="deleteMppFile(null)">删除</el-button>
                <el-cascader
                  style="margin-left: 10px;width:150px"
                  :options="treess"
                  v-model="editFolder"
                  placeholder="文件移动至"
                  :disabled="multipleSelection.length <= 0"
                  size="small"
                  :props="{ checkStrictly: true, label: 'folderName', value: 'id', emitPath:false }"
                  clearable>
                </el-cascader>
                <el-button style="margin-left: 10px;" type="primary" size="small" icon="el-icon-rank" :disabled="multipleSelection.length <= 0 || editFolder == ''" @click="editMpp()">移动
                </el-button>
          </div>

          <div class="icon-group">
            <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
            <span title="搜索" class="icon-box" @click="search">
              <Icon color="#606266">
                <Search />
              </Icon>
            </span>
<!--            <span title="下载模板" class="icon-box" @click="importTemplate">-->
<!--              <Icon color="#606266">-->
<!--                <ArrowDown />-->
<!--              </Icon>-->
<!--            </span>-->
<!--            <span class="icon-box" title="导入数据" @click="isImport">-->
<!--              <Icon color="#606266">-->
<!--                <ArrowExportUp24Regular />-->
<!--              </Icon>-->
<!--            </span>-->
<!--            <span title="导出数据" class="icon-box" @click="exportMppFileList">-->
<!--              <Icon color="#606266">-->
<!--                <ArrowDownload24Regular />-->
<!--              </Icon>-->
<!--            </span>-->
            <span class="icon-box" @click="refreshMppFileList">
              <Icon color="#606266">
                <Refresh />
              </Icon>
            </span>
            <span style="height: 100%;margin-left: 10px;position: relative;top: -5px;">
              <el-radio-group v-model="switchof1">
                <el-radio-button :label="true"><i class="el-icon-menu"></i></el-radio-button>
                <el-radio-button :label="false"><i class="el-icon-s-operation"></i></el-radio-button>
              </el-radio-group>
            </span>
          </div>
        </div>
        <el-table :data="mppFileList" row-key="id" border height="85%" :header-row-style="{ height: '10px' }"
          :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
          @selection-change="handleSelectionChange1" size="small">
          <el-table-column align="center" type="selection" width="60"> </el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" prop="fileName" label="图片名称" min-width="360px">
            <template slot-scope="scope">
              <div v-if='scope.row.fileUrl' style="display: flex;justify-content: center;align-items: center;">
                <el-image @click='updateSrcList(scope.row.fileUrl)' style="width: 60px; height: 60px"
                  :src="scope.row.fileUrl" :preview-src-list="srcList"> </el-image>
                <div style="flex:1;text-align: left;margin-left: 8px;overflow: hidden;">
                  <div v-if="!scope.row.edit">{{ scope.row.fileName }}</div>
                  <el-input v-else v-model="scope.row.inp" size="small" placeholder="请输入内容"></el-input>
                </div>
              </div>
            <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="createTime" label="上传时间" min-width="180px">
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="220">
            <template slot-scope="scop">
              <div class="operation">
                <div v-if="scop.row.fileType >= 2 && scop.row.fileType <= 5" @click="updateSrcList1(scop.row.fileUrl)">
                  <Icon size="16">
                    <Eye24Regular />
                  </Icon>
                  <span>
                    <el-image
                      ref="images" v-show="false" style="width: 10px; height: 10px"
                      :src="scop.row.fileUrl"
                      :preview-src-list="srcList">
                    </el-image>
                    查看</span>
                </div>
                <div v-else-if="scop.row.fileType == 1 || scop.row.fileType == 6 || scop.row.fileType >= 8" @click="onUpload(scop.row.fileUrl)">
                  <Icon size="16">
                    <Eye24Regular />
                  </Icon>
                  <span >
                    下载
                  </span>
                </div>
                <div v-else-if="scop.row.fileType == 7" @click="playVideoVideo(scop.row.fileUrl)">
                  <Icon size="16">
                    <Eye24Regular />
                  </Icon>
                  <span>
                    播放
                  </span>
                </div>
                <div @click="edit1(scop.row.id)">
                  <Icon size="16">
                    <Edit24Regular />
                  </Icon>
                  <span class="operation-label">{{ scop.row.edit == true ? '确定' : '重命名' }}</span>
                </div>
                <div @click="deleteMppFile(scop.row.id)">
                  <Icon size="16" style="color: red">
                    <Delete24Regular />
                  </Icon>
                  <span class="operation-label" style="color: red">删除</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
            :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum" background :pager-count="7">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog :title="mppFileStates[mppFileState]" :visible.sync="showDialog" width="400px" @close="closeDialog">
          <div>
            <el-form :model="mppFile" ref="mppFileForm" :rules="rules" label-width="120px" size="small">
              <el-form-item label="上传类型" prop="fileName">
                <!-- <el-input style="width: 200px;" size="small" v-model="mppFile.fileName" :disabled="mppFileState == 'check'"></el-input> -->
                <el-radio-group v-model="radiouser">
                  <el-radio :label="0">图片</el-radio>
                  <el-radio :label="1">文件</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="上传至文件夹" prop="folderId">
                <!-- <el-input size="small" v-model="mppFile.deleteFlag" :disabled="mppFileState == 'check'"></el-input> -->
                <el-select
                  style="width: 200px"
                  v-model="mppFile.folderId"
                  placeholder="请选择文件夹名称"
                  :disabled="mppFileState == 'check'"
                  clearable
                  size="small"
              >
                  <el-tree default-expand-all :data="trees" :props="{ children: 'children', label: 'folderName' }">
                      <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                          <el-option :label="node.label == '全部文件' ? '顶级分类' : node.label" :value="data.id"> </el-option>
                      </div>
                  </el-tree>
                </el-select>
              </el-form-item>
            <el-form-item label="上传" prop="file">
              <!-- <el-input size="small" v-model="mppFile.fileName" :disabled="mppFileState == 'check'"></el-input> -->
              <el-upload :action="action" ref="uploads" :headers="header"
                class="avatar-uploader" :show-file-list="false" :http-request="uploadImage">
                <img v-if="mppFile.url != '' && radiouser == 0" :src="mppFile.url" class="avatar" size="small" />
                <span v-else-if="mppFile.url != '' && radiouser == 1">
                  <el-result icon="success" title="文件上传成功">
                  </el-result>
                </span>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">只能上传{{ this.userinfo[this.radiouser].type }}格式，且不超过{{ this.userinfo[this.radiouser].size }}M</div>
              </el-upload>
            </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="flex justify-end">
            <el-button @click="closeDialog">关闭</el-button>
            <el-button type="primary" @click="submitForm" v-if="mppFileState != 'check'">确定</el-button>
          </div>
        </el-dialog>
        <playVideo ref="videoDiolag"></playVideo>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API } from '@/utils/constant.js';
import playVideo from '@/components/video/playVideo.vue';
export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    playVideo
  },
  watch: {
    trees(val) {
      this.treess = this.removeEmptyChildrenFromArray(this.trees)
    },
    switchof1() {
      console.log(this.switchof1)
      this.multipleSelection = []
      // for (let iterator of this.mppFileList) {
      //   iterator.checked = false
      //   iterator.edit = false
      // }
      console.log(this.treess)
      this.resetMppFileList()
      this.getMppFileList()
    },
    checkState(val) {
      if (val == 'check') {
          this.$emit('resetCheckState', val);
        this.$nextTick(()=>{
            this.resetMppFileList();
            this.getMppFileList(this.queryForm);
        })
      } else if (val == 'reset') {
          this.$emit('resetCheckState', val);
          this.$nextTick(()=>{
              this.resetMppFileList();
              this.getMppFileList(this.queryForm);
          })
      }
    }
  },
  props: {
    checkState: {
      type: String,
      default: ''
    },
    queryForm: {
      type: Object,
      default: {}
    },
    trees: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      treess:[],
      header: {
        token: localStorage.getItem('token')
      },
      action: UPLOAD_API + UPLOAD_PATH,
      srcList: [''],//大图预览
      loading: false,
      showDialog: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      mppFileState: 'edit',
      mppFileStates: {
        add: '上传文件',
        check: '查看mpp_file',
        edit: '修改文件'
      },
      queryForm:{
        fileName:""
      },
      multipleSelection: [],
      mppFileList: [],
      mppFile: {
        id: '', //ID
        folderId: "0",
        url:"",
      },
      pageSizes: 50,
      btnLoading: false,
      switchof1: true,
      rules: {
        id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
        file: [{ required: true, message: '文件不能为空', trigger: 'blur' }],
        folderId: [{ required: true, message: '父级文件夹不能为空', trigger: 'blur' }]
      },
      radiouser: 0,
      userinfo:[{size:0,type:""},{size:0,type:""}],
      editFolder:'',
      // fileType:[],
    };
  },
  created() {
    this.getMppFileList();
    this.ggget();
    // this.getFildid();
    // this.getType();
  },
  mounted(){
  },
  methods: {
    getType(){
      get('/mpp/utils/getEnum', {
        enumType: 'file_type',
      }).then((res) => {
        if (res.success) {
          // console.log(res.enumList)
          this.fileType = res.enumList
        }
      })
    },
    // getFildid(){
    //   get(`/mpp/filefolder/findAllAsTree`, {}).then((res) => {
    //     this.loading = false;
    //     if (res.success) {
    //       res.treeData.unshift({id:"0",folderName:'全部文件',children:[]})
    //       this.treess = res.treeData;
    //       this.treess = this.removeEmptyChildrenFromArray(this.trees)
    //       console.log(this.treess);
    //       // this.totalNum = res.page.total;
    //     } else {
    //       this.$message({
    //         message: res.msg,
    //         type: 'error',
    //         duration: 2000
    //       });
    //     }
    //   });
    // },
    // 播放
    playVideoVideo(src) {
      console.log(src + "哈哈哈")
      this.$refs.videoDiolag.dialogVisible = true
      this.$refs.videoDiolag.videoSrc = src
    },
    onUpload(url){
      // window.open(url);
      const a = document.createElement('a');
      a.style.display = 'none';
      document.body.appendChild(a);

      // 设置下载链接和默认文件名
      a.href = url;
      a.download = url.split('/').pop(); // 使用URL的最后一部分作为默认文件名

      // 触发点击事件开始下载
      a.click();

      // 下载完成后从DOM中移除元素（非必须）
      setTimeout(() => {
        document.body.removeChild(a);
      }, 0);
    },
    editMpp(val){
      if(!val){
        console.log(this.editFolder)
        if(this.editFolder == '' || !this.editFolder){
          return
        }
        let ids = this.multipleSelection.map((mppFile) => mppFile.id).join(',');
        get(`/mpp/file/transfer`,{ids:ids,folderId:this.editFolder}).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetMppFileList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
      }
    },
    removeEmptyChildrenFromArray(treeData) {
      return treeData.reduce((acc, item) => {
        if (Array.isArray(item.children)) {
          // 如果children为空数组，则删除children属性
          if (item.children.length === 0) {
            delete item.children;
          } else {
            // 否则递归处理子元素
            item.children = this.removeEmptyChildrenFromArray(item.children);
          }
        }
        
        // 只有在清理完children后非空的对象才会被添加回结果数组中
        if (Object.keys(item).length > 0) {
          acc.push(item);
        }

        return acc;
      }, []);
    },
    // removeEmptyChildren(arr) {
    //   return arr.map(item => {
    //     // 深度遍历并移除空的children
    //     if (Array.isArray(item.children)) {
    //       item.children = removeEmptyChildren(item.children);
    //       // 如果处理后children为空数组，则删除children属性
    //       if (item.children.length === 0) {
    //         delete item.children;
    //       }
    //     }
    //     return item;
    //   });
    // },
    // getlll(array = []) {
    //   return array.filter(item => {
    //     if (Array.isArray(item.children) && !item.children.length) {
    //       delete item.children; // 可选：直接删除空children属性
    //       return false; // 不返回该元素到结果数组中
    //     } else{
    //       // 如果item是对象且有children属性，则递归处理其children
    //       item.children = getlll(item.children);
    //     }
    //     // 返回所有非空对象或非对象的项
    //     return true;
    //   });
    // },
    // gettrees(array=[]){
    //   for (const key in array) {
    //     if (array[key].children.length > 0 ) {
    //       array[key] = this.gettrees(array[key])
    //     }else{
    //       return delete array[key].children
    //     }
    //   }
    //   console.log(array)
    // },
    ggget(){
      get(`/mpp/utils/getUploadLimit`).then((res) => {
          console.log(res)
          if(res.success){
            this.userinfo[0] = { size: res.imageMaxSize, type: res.imageSuffix }
            this.userinfo[1] = { size: res.fileMaxSize, type: res.fileSuffix }
              this.$emit('getUserinfo',[...res.imageSuffix.split(","), ...res.fileSuffix.split(",")])
          }
      })
    },
    rst(){
      this.multipleSelection = []
      for (let iterator of this.mppFileList) {
        iterator.checked = false
        iterator.edit = false
      }
    },
    uploadImages() {
      this.$refs.uploads.$el.querySelector(".as").click()
      console.log(this.$refs.uploads)
    },
    //上传缩略图
    uploadImage(params) {
      const file = params.file;
      const formData = new FormData();
      
      formData.append('file', file);
      console.log(formData)
      upload( this.radiouser == 0 ? UPLOAD_PATH : `/mpp/file/upload`, formData).then((res) => {
        if (res.success) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 2000
          });
          this.mppFile.url = res.url
          this.mppFile.id = res.id
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    handleSelectionChange1(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    edit1(id) {
      this.mppFileList.forEach(element => {
        if (element.id == id) {
          element.edit = !element.edit
          console.log("ok")
          if (element.edit) {
            element.inp = element.fileName
            console.log("??")
          } else {
            if (element.inp == element.fileName) {
              console.log("???")
              return
            } else {
              console.log("okk")
              this.mppFileState = 'edit'
              this.mppFile.id = element.id
              this.mppFile.fileName = element.inp
              element.fileName = element.inp
              this.submitForm()
            }
          }
        }
      });
    },
    // 大图预览
    updateSrcList(src) {
      this.srcList[0] = src
      this.$refs.image[0].showViewer = true;
    },
    updateSrcList1(src) {
      this.srcList[0] = src
      console.log(this.$refs.images)
      this.$refs.images.showViewer = true;
    },
    mouseoverleave(id, sign) {
      console.log(id, sign)
      for (let iterator of this.mppFileList) {
        if (iterator.id == id) {
          iterator.hover = sign
        }
      }
    },
    search() {
      this.isSearch = !this.isSearch;
      this.$emit("isSearch", this.isSearch)
    },
    resetMppFileList() {
      this.pageSize = 10;
      this.pageSizes = 50;
      this.currentPage = 1;
      this.mppFileList = [];
      this.rst();
    },
    resetDialog() {
      this.mppFileState = 'add';
      this.showDialog = false;
      this.queryForm = {
        id: '', //ID
        fileName: '', //文件名
        newFileName: '', //新文件名
        fileType: '', //文件类型
        fileSuffix: '', //文件后缀
        filePath: '', //文件路径
        fileSize: '', //文件大小
        folderId: '', //文件夹
      };
      this.getMppFileList();
    },
    closeDialog() {
      this.showDialog = false
      this.mppFile = {
        id: '', //ID
        folderId: "0",
        url:"",
      };
      this.radiouser = 0
    },
    submitForm() {
      if (this.mppFileState == 'add') {
        this.$refs.mppFileForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            console.log(this.mppFile)
            post(`/mpp/file/add`, { ...this.mppFile }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetMppFileList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.mppFileState == 'edit') {
        delete this.mppFile.url;
        console.log('submit');
        post(`/mpp/file/edit`, { ...this.mppFile }).then((res) => {
          if (res.success) {
            this.$message({
              message: res.msg,
              type: 'success',
              duration: 2000
            });
            this.resetMppFileList();
            this.resetDialog();
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 2000
            });
          }
        });
      }
    },
    addMppFile() {
      this.showDialog = true;
      this.mppFileState = 'edit';
    },
    checkMppFile(mppFileId) {
      console.log(mppFileId);
      this.currentMppFileId = mppFileId;

      this.getMppFileById();
      this.showDialog = true;
      this.mppFileState = 'check';
    },
    editMppFile(mppFileId) {
      console.log('mppFile', mppFileId);
      if (mppFileId) {
        this.currentMppFileId = mppFileId;
        this.getMppFileById();
      } else {
        this.mppFile = { ...this.mppFile, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.mppFileState = 'edit';
    },
    deleteMppFile(mppFileId) {
      let ids = '';
      if (mppFileId) {
        ids = mppFileId;
      } else {
        ids = this.multipleSelection.map((mppFile) => mppFile.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/mpp/file/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetMppFileList();
              this.getMppFileList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshMppFileList() {
      this.resetMppFileList();
      this.getMppFileList();
    },
    getMppFileList(query = {}) {
      this.loading = true;
      console.log(this.queryForm)
      get(`/mpp/file/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.switchof1 ? this.pageSizes : this.pageSize, ...query }).then((res) => {
        this.loading = false;
        if (res.success) {
          res.page.list.forEach(element => {
            element.hover = false
            element.checked = false
            element.number = 0
            element.edit = false
            element.inp = ''
          });
          this.mppFileList = res.page.list;
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getMppFileById() {
      get(`/mpp/file/get`, { id: this.currentMppFileId }).then((res) => {
        if (res.success) {
          this.mppFile = { ...this.mppFile, ...res.mppFile };
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportMppFileList() {
      //this.btnLoading = true;
      exprotExcel(`/mpp/file/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/mpp/file/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/mpp/file/importData`, formData);
      this.refreshMppFileList();
    },
    handleSelectionChange(id) {
      this.mppFileList.forEach((element, key) => {
        if (element.id == id) {
          element.checked = !element.checked
        }
        if (element.checked == false) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            if (this.multipleSelection[i].checked == false) {
              this.multipleSelection.splice(i, 1)
            }
          }
        } else {
          let bool = false
          for (let i = 0; i < this.multipleSelection.length; i++) {
            if (this.multipleSelection[i].id == element.id) {
              bool = true
              break
            }
          }
          if (!bool) {
            this.multipleSelection.push(element)
          }
        }
        // if(element.checked){
        //   this.multipleSelection.push(element)
        // }else{
        //   for(let i = 0;i<this.multipleSelection.length;i++){
        //     if(this.multipleSelection[i].checked == false){
        //       this.multipleSelection.splice(key,1)
        //     }
        //   }
        // }
      });
      let count = 0
      for (const iterator of this.multipleSelection) {
        for (let iterator1 of this.mppFileList) {
          if (iterator.id == iterator1.id) {
            count++
            iterator1.number = count
            console.log(count)
          }
        }
      }

      console.log(this.multipleSelection);
      // this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getMppFileList();
      this.rst();
    },
    sizeChange(size) {
      this.pageSize = size;

      this.getMppFileList();
      this.rst();
    },
    sizeChanges(size){
      this.pageSizes = size;
      this.getMppFileList();
      this.rst();
    },
  }

};
</script>

<style lang="scss" scoped>
.page-content1 {
  background-color: #fff;
  width: -webkit-fill-available;
  padding: 10px
}

.content {
  width: 100%;
  height: 100%;

  .pictrueArea {
    width: 100%;
    min-height: 90%;
    margin-bottom: 10px !important;

    .items {
      display: flex;
      // justify-content: space-around;
      flex-wrap: wrap;
    }

    .number {
      height: 33px;
      position: absolute;
      right: 0;
      top: 0;
    }

    .imgOn {
      background-color: #f8f8f8;
      border: 2px solid #0256ff;
      width: 130px;
      height: 138px;
      padding: 1px;
    }

    .pictrueitem {
      width: 130px;
      position: relative;
      cursor: pointer;
      margin: 14px;

      .img {
        background-color: #f8f8f8;
        width: 130px;
        height: 138px;
        padding: 3px;
      }

      .operate-item {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 4px;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 20px;
          font-size: 12px;
          color: #515a6d;
          text-align: center;
        }

        .operate-height {
          height: 16px;
          position: absolute;
          bottom: -10px;
          padding: 5px 0;
          width: 100%;
          display: flex;
          justify-content: space-evenly;

          span {
            font-size: 11px;
            color: #409eff;
          }
        }
      }
    }
  }
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}

.avatar {
  width: 200px;
  height: 200px;
  display: block;
}

::v-deep .el-upload--text {
  width: 200px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .el-range-separator{
  width: 20px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}
.el-icon-check {
  font-size: 60px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}


</style>